/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC} from 'react'
import {FormattedMessage} from 'react-intl'
import {KTSVG} from '../../../helpers'
import {ThemeModeType, systemMode, useThemeMode} from '../theme-mode/ThemeModeProvider'

const ThemeMode: FC = () => {
  const {menuMode, updateMode, updateMenuMode} = useThemeMode()
  const currentMode = menuMode === 'system' ? systemMode : menuMode
  const switchMode = (_mode: ThemeModeType) => {
    updateMenuMode(_mode)
    updateMode(_mode)
  }

  return (
    <div
      className='menu-item px-5'
      data-kt-menu-trigger='hover'
      data-kt-menu-placement='left-start'
      data-kt-menu-flip='bottom'
    >
      <a href='#' className='menu-link px-5'>
        <span className='menu-title position-relative'>
          &nbsp;&nbsp;{<FormattedMessage id='USER_MENU.MODE' />}
          <span className='fs-8 rounded bg-light px-3 py-2 position-absolute translate-middle-y top-50 end-0'>
            {
              <FormattedMessage
                id={currentMode === 'dark' ? 'USER_MENU.THEME_DARK' : 'USER_MENU.THEME_LIGHT'}
              />
            }
          </span>
        </span>
      </a>

      <div className='menu-sub menu-sub-dropdown w-175px py-4'>
        <div className='menu-item px-3'>
          <a
            href='#'
            className={clsx('menu-link d-flex px-5', {active: menuMode === 'light'})}
            onClick={() => switchMode('light')}
          >
            <span className='menu-icon' data-kt-element='icon'>
              <KTSVG path='/media/icons/duotune/general/gen060.svg' className='svg-icon-3' />
            </span>
            {<FormattedMessage id='USER_MENU.THEME_LIGHT' />}
          </a>
        </div>

        <div className='menu-item px-3'>
          <a
            href='#'
            className={clsx('menu-link d-flex px-5', {active: menuMode === 'dark'})}
            onClick={() => switchMode('dark')}
          >
            <span className='menu-icon' data-kt-element='icon'>
              <KTSVG path='/media/icons/duotune/general/gen061.svg' className='svg-icon-3' />
            </span>
            {<FormattedMessage id='USER_MENU.THEME_DARK' />}
          </a>
        </div>
      </div>
    </div>
  )
}

export {ThemeMode}
